import { Link } from 'react-router-dom';
import { NAV, SERVICES, SITE } from '../data';
import Icon from './Icon';

const LEGAL = [
  { label: 'Privacy Policy', to: '/privacy' },
  { label: 'Terms of Service', to: '/terms' },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-ink text-white">
      {/* CTA band */}
      <div className="container-x relative -mt-px py-16">
        <div className="relative overflow-hidden rounded-[2rem] bg-gradient-to-r from-brand to-brand-dark p-10 text-center sm:p-14" data-anim="zoom">
          <div className="grid-bg absolute inset-0 opacity-50" />
          <div className="relative">
            <h2 className="h2 mx-auto max-w-3xl">Ready to launch your next <span className="text-accent-light">digital</span> <span className="text-outline-light">product</span>?</h2>
            <p className="mx-auto mt-4 max-w-xl text-white/75">Get a free consultation and a no-obligation quote from our team.</p>
            <Link to="/contact" className="btn-primary mt-8">Get a free quote <Icon name="arrow" className="h-4 w-4" /></Link>
          </div>
        </div>
      </div>

      <div className="container-x grid gap-12 border-t border-white/10 py-14 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1.2fr_1.2fr]">
        <div>
          <img src="/logo.png" alt="Origo Private Limited" className="h-12 w-auto sm:h-14" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">Websites, mobile apps, design, animation and digital marketing — delivered by one dedicated team.</p>
        </div>
        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-widest text-brand-lime">Company</h3>
          <ul className="mt-5 space-y-3 text-sm text-white/70">
            {NAV.map((l) => <li key={l.to}><Link to={l.to} className="transition-colors hover:text-brand-lime">{l.label}</Link></li>)}
          </ul>
        </div>
        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-widest text-brand-lime">Services</h3>
          <ul className="mt-5 space-y-3 text-sm text-white/70">
            {SERVICES.slice(0, 7).map((s) => <li key={s.slug}><Link to={`/services/${s.slug}`} className="transition-colors hover:text-brand-lime">{s.title}</Link></li>)}
            <li><Link to="/services" className="font-medium text-brand-lime">View all services →</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-widest text-brand-lime">Get in touch</h3>
          <ul className="mt-5 space-y-3 text-sm text-white/70">
            <li><a href={`mailto:${SITE.email}`} className="hover:text-brand-lime">{SITE.email}</a></li>
            <li><a href={`tel:${SITE.phone.replace(/[^+\d]/g, '')}`} className="hover:text-brand-lime">{SITE.phone}</a></li>
            <li>{SITE.address}</li>
            <li>{SITE.hours}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-6">
        <div className="container-x flex flex-col items-center justify-between gap-3 text-sm text-white/50 sm:flex-row">
          <p>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
          <div className="flex gap-6">
            {LEGAL.map((l) => <Link key={l.to} to={l.to} className="hover:text-brand-lime">{l.label}</Link>)}
          </div>
        </div>
      </div>
    </footer>
  );
}
